import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { getUserProfile } from "@js/api/domain/user";
export const useUserStore = defineStore('user', () => {
    const profile = ref(null);
    const isLoaded = ref(false);
    const isAuthenticated = computed(() => !!profile.value);
    const brandID = computed(() => profile.value?.brandId ?? null);
    const brandName = computed(() => profile.value?.brandName ?? 'N/A');
    const permissions = computed(() => profile.value?.permissions);
    const isAdmin = computed(() => profile.value?.permissions.isAdmin ?? false);
    const isStoreManager = computed(() => profile.value?.permissions.isStoreManager ?? false);
    const isGraphicArtist = computed(() => profile.value?.permissions.isGraphicArtist ?? false);
    const canSeeCut = computed(() => profile.value?.permissions.canSeeCutOrderBucket ?? false);
    const canSeeSewn = computed(() => profile.value?.permissions.canSeeSewnOrderBucket ?? false);
    const canSeeAllBrands = computed(() => profile.value?.permissions.canSeeAllBrands ?? false);
    async function fetchUser() {
        try {
            const { data } = await getUserProfile();
            profile.value = data;
        }
        catch (err) {
            profile.value = null;
            console.error("Auth Error", err);
        }
        finally {
            isLoaded.value = true;
        }
    }
    return {
        profile,
        isLoaded,
        isAuthenticated,
        brandID,
        brandName,
        permissions,
        isAdmin,
        isStoreManager,
        isGraphicArtist,
        canSeeCut,
        canSeeSewn,
        canSeeAllBrands,
        fetchUser,
    };
});
